<template>
    <div v-if="isShowEdu"
        class="edu">
        <div class="edu-content">
            <div class="edu-title">EDU教育认证</div>
            <div class="edu-x"
                @click="close()">
                <img src="static/image/closeIcon.png"
                    alt="">
            </div>
            <!-- 没有认证过edu身份输入身份信息弹框 -->
            <div v-if="inputInfoPop"
                class="input-info-pop">
                <!-- 姓名 -->
                <div class="main-content">
                    <div class="left">
                        <div><span>*</span>姓名</div>
                    </div>
                    <input class="right-input"
                        :class="{'red-border': nameFlag}"
                        v-model="userName"
                        :placeholder="'请输入姓名'"
                        autocomplete="off"
                        :maxlength="20"
                        @blur="blurName">
                </div>
                <!-- 学校 -->
                <div class="main-content">
                    <div class="left">
                        <div><span>*</span>学校</div>
                    </div>
                    <input class="right-input"
                        :class="{'red-border': schoolFlag}"
                        v-model="university"
                        :placeholder="'请输入学校'"
                        autocomplete="off"
                        :maxlength="20"
                        @blur="blurSchool">
                </div>
                <!-- 身份 -->
                <div class="main-content">
                    <div class="left">
                        <div><span>*</span>身份</div>
                    </div>
                    <dropdown v-model="identity"
                        class="right-input"
                        :class="{'red-border': identityFlag}"
                        :dataCfg="userTypeDataCfg"
                        :label="'itemName'"
                        :code="'itemCode'"
                        clearable
                        @onChange="changeIdentity" ></dropdown>
                </div>
                <!-- EDU教育邮箱 -->
                <div class="main-content main-content-bottom">
                    <div class="left">
                        <div>
                            <div class="text"><span>*</span>EDU教育</div>
                            <div>邮箱</div>
                        </div>
                    </div>
                    <input class="right-input"
                        :class="{'red-border': eduEmailFlag}"
                        v-model="email"
                        :placeholder="'请输入EDU教育邮箱'"
                        autocomplete="off"
                        :maxlength="64"
                        @blur="blurEduEmail">
                </div>
                <div class="main-content-tip">
                    请填写edu.cn(或edu)结尾的邮箱
                </div>
                <div class="big-button"
                    @click="sendEmail()">发送认证邮件</div>
            </div>
            <!-- 验证过edu身份，但已过期 -->
            <div v-if="cacheInvalidation"
                class="cache-invalidation">
                <div class="cache-invalidation-content span-emil-style">
                    <div>
                        <div>!</div>
                    </div>
                    <div>您的EDU邮箱<span>（{{ email.length > 20 ? email.slice(0,20) + '...' : email }}）</span>已失效，请重新认证</div>
                </div>
                <div class="big-button"
                    @click="reCertification()">重新认证</div>
            </div>
            <!-- 输入验证码弹框部分 -->
            <div v-if="enterVerificationCode"
                class="enter-verification-code span-emil-style">
                <div class="text">认证邮件已发送到您EDU邮箱<span>（{{ email.length > 20 ? email.slice(0,20) + '...' : email }}）</span>，3分钟内有效，请输入邮箱中的验证码完成认证</div>
                <div class="main-content resend-parent">
                    <div class="left left-code">验证码</div>
                    <input class="right-input"
                        v-model="verificationCode"
                        :placeholder="'请输入验证码'"
                        autocomplete="off"
                        style="width:100%">
                    <!-- 重新发送按钮不禁用 -->
                    <div v-if="isShowReSendBtn && !disabled" class="resend" @click="reSendCode()">重新发送</div>
                    <!-- 重新发送按钮禁用 -->
                    <div v-if="isShowReSendBtn && disabled" class="resend resend-not">重新发送</div>
                </div>
                <div class="button">
                    <div class="left-button common"
                        @click="reCertification()">重新绑定EDU邮箱</div>
                    <div class="right-button common" @click="goImmediateAuthentication()">立即认证</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Toast } from 'vant';
import { CouponType } from '../../../../commons/commonVariables.js';
export default {
  components: {},
  props: {
    isShowEdu: {
      type: Boolean,
      default: false,
    },
    inputInfoPop: {
      type: Boolean,
      default: false,
    },
    cacheInvalidation: {
      type: Boolean,
      default: false,
    },
    enterVerificationCode: {
      type: Boolean,
      default: false,
    },
    elementParentObj: {
      type: Object,
      default: () => {
        return {}
      }
    },
    clickElementObj: {
      type: Object,
      default: () => {
        return {}
      }
    },
    clickIndex: {
      type: Number,
      default: null,
    },
    handleReceivecoupon: {
      type: Function,
      default: () => {
        return () => {}
      }
    },
    receiveAward: {
      type: Function,
      default: () => {
        return () => {}
      }
    },
    receiveEquityPackage: {
      type: Function,
      default: () => {
        return () => {}
      }
    },
    getAllData: {
      type: Function,
      default: () => {
        return () => {};
      },
    },
    oldUserInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSource: {
      type: String,
      default: '',
    },
  },
  watch: {
  },
  data() {
    return {
      email: '',
      identity: '',
      userName: '',
      university: '',
      verificationCode: '',
      nameFlag: false,
      schoolFlag: false,
      identityFlag: false,
      eduEmailFlag: false,
      isShowReSendBtn: false,
      disabled: false,
      userTypeDataCfg: {
        sc:"mobileUser",
        url:'lookUpManage/listPermissionTypeAndSys',
        params:{"classifyCode":"ihlp.marketing.edu.identity"}
      },
    };
  },
  computed: {},
  created() {
    const data = this.oldUserInfo;
    if(data && data.id) {
      this.userName = data.userName;
      this.email = data.email;
      this.identity = data.identity;
      this.university = data.university;
    }
  },
  mounted() {},
  methods: {
    blurName() {
      if (this.userName) {
        this.nameFlag = false;
      }
    },
    blurSchool() {
      if (this.university) {
        this.schoolFlag = false;
      }
    },
    blurEduEmail() {
      if (this.email) {
        this.eduEmailFlag = false;
      }
    },
    changeIdentity(itemCode) {
      this.identity = itemCode;
      if(this.identity) {
        this.identityFlag = false;
      }
    },
    // 邮箱正则校验
    checkEduEmail() {
      const reg = /^[A-Za-z0-9+_.-]+@([A-Za-z0-9-]+\.)+(edu|edu.cn)$/;
      if (!reg.test(this.email)) {
        Toast('请填写edu.cn（或edu）结尾的邮箱');
        return false;
      } else {
        return true
      }
    },
    // 发送认证邮件
    sendEmail() {
      if (!this.userName || !this.university || !this.identity || !this.email) {
        Toast('请完善认证信息!');
        if (!this.userName) {
          this.nameFlag = true;
        }
        if (!this.university) {
          this.schoolFlag = true;
        }
        if (!this.email) {
          this.eduEmailFlag = true;
        }
        if (!this.identity) {
          this.identityFlag = true;
        }
        return;
      } else {
        const flag = this.checkEduEmail();
        if (!flag) {
          this.eduEmailFlag = true;
          return;
        }
        this.clickSendEmailCode();
      }
      this.$emit('changeBoundingBox', {cacheInvalidation: false, enterVerificationCode: true, inputInfoPop: false})
    },
    clickSendEmailCode() {
      const params = {
        userName: this.userName,
        university: this.university,
        identity: this.identity,
        email: this.email,
      }
      this.$api.post({
        sc: 'mobileMarketing',
        url: `edu/certification/send_email_verification_code`,
        params: params,
        success: (res) => {
          if(res.code === 200 && res.result) {
            this.redisKey = res.result;
          } else {
            Toast(res.message);
          }
        },
      });
    },
    // 立即认证
    goImmediateAuthentication() {
      if(!this.verificationCode) {
        Toast('请输入验证码!')
        return
      }
      const params = {
        userName: this.userName,
        university: this.university,
        identity: this.identity,
        email: this.email,
        verificationCode: this.verificationCode,
        redisKey: this.redisKey,
      }
      this.$api.post({
        sc: 'mobileMarketing',
        url: `edu/certification/verify_and_save`,
        params: params,
        success: (res) => {
          if(res.code === 200) {
            // 执行祖父组件中的领取券方法
            if (this.pageSource === 'bigTurntable') {
              this.getAllData();
            } else {
              // 优惠券
              if (this.elementParentObj.pageType === CouponType.coupon) {
                this.handleReceivecoupon(this.clickElementObj, this.elementParentObj, this.clickIndex);
              }
              // 代金券、权益品
              if (this.clickElementObj.pageType === CouponType.voucher || this.clickElementObj.pageType === CouponType.exchangegoods) {
                this.receiveAward(this.clickElementObj, this.clickIndex);
              }
              // 权益包
              if (this.clickElementObj.pageType === CouponType.EQUITY_PACKAGE) {
                this.receiveEquityPackage(this.clickElementObj, this.clickIndex);
              }
            }
            this.$emit('changeBoundingBox', { cacheInvalidation: false, enterVerificationCode: false, inputInfoPop: false, isShowEdu: false });
          } else if (res.code === 500) {
            this.isShowReSendBtn = true;
            this.disabled = false;
            Toast(res.message);
          } else {
            Toast(res.message);
          }
        },
      });
    },
    // 重新认证
    reCertification() {
      this.$emit('changeBoundingBox', {cacheInvalidation: false, enterVerificationCode: false, inputInfoPop: true})
    },
    close() {
      this.$emit('closeEdu');
    },
    // 重新发送验证码
    reSendCode() {
      this.disabled = true;
      this.verificationCode = '';
      this.sendEmail();
    },
  },
};
</script>
<style scoped lang="scss">
.edu {
  .edu-content {
    .cache-invalidation-content {
      display: flex;
      :first-child {
        width: 23.5px;
        padding-top: 0.5vw;
        :first-child {
          background: #ec5650;
          width: 16px;
          height: 16px;
          border-radius: 50%;
          color: #ffffff;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      :last-child {
        font-size: 3.733vw;
        color: #000000;
        line-height: 5.333vw;
        font-weight: 400;
        margin-left: 7.5px;
      }
    }
    .big-button {
      width: 100%;
      height: 10.667vw;
      background: #256fff;
      border-radius: 5.333vw;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 3.733vw;
      color: #ffffff;
      letter-spacing: 0;
      text-align: center;
      line-height: 5.6vw;
      font-weight: 400;
      margin-top: 6.133vw;
    }
    .edu-title {
      font-size: 4.8vw;
      color: #000000;
      letter-spacing: 0;
      text-align: center;
      line-height: 6.667vw;
      font-weight: 400;
      margin-bottom: 5.867vw;
    }
    .resend-parent {
      position: relative;
      .resend {
        position: absolute;
        right: 1.867vw;
        font-size: 3.733vw;
        color: #256FFF;
        line-height: 32px;
        font-weight: 400;
      }
      .resend-not {
        opacity: 0.38;
      }
    }
    .main-content {
      display: flex;
      height: 8.533vw;
      align-items: center;
      margin-bottom: 2.667vw;
      .left {
        width: 19.667vw;
        font-size: 3.733vw;
        color: #666666;
        line-height: 4.533vw;
        font-weight: 400;
        text-align: right;
        margin-right: 2.133vw;
        display: flex;
        justify-content: flex-end;
        span {
          color: #e0282e;
        }
      }
      .text {
        width: 100%;
      }
      .left-code {
        text-align: left;
        margin-right: 0;
        width: 13.867vw;
        justify-content: flex-start;
      }
      .right-input {
        flex: 1;
        width: calc(100% - 21.8vw);
        height: 100%;
        background: #ffffff;
        border: 1px solid #d3d3d3;
        border-radius: 1.333vw;
        padding: 0 1.867vw;
        font-size: 3.733vw;
        color: #000000;
        letter-spacing: 0;
        font-weight: 400;
      }
      .red-border {
        border: 1px solid #e0282e;
      }
      input::placeholder {
        font-size: 3.733vw;
        color: #d3d3d3;
        letter-spacing: 0;
        font-weight: 400;
      }
    }
    .main-content-bottom {
      margin-bottom: 1.6vw;
    }
    .main-content-tip {
      font-size: 3.2vw;
      color: #e0282e;
      line-height: 4.533vw;
      font-weight: 400;
      padding-left: 23.667vw;
    }
    .edu-x {
      img {
        position: absolute;
        right: 12px;
        top: 12px;
        width: 12px;
        height: 12px;
      }
    }
    .span-emil-style {
      span {
        word-break: break-all;
        white-space: normal;
      }
    }
    .enter-verification-code {
      .text {
        font-size: 3.733vw;
        color: #000000;
        line-height: 5.333vw;
        font-weight: 400;
        margin-bottom: 4vw;
      }
      .button {
        display: flex;
        justify-content: space-around;
        margin-top: 4vw;
        .left-button {
          width: 40vw;
          height: 10.667vw;
          background: #f2f2f2;
          color: #256fff;
          margin-right: 2.667vw;
        }
        .right-button {
          width: 33.333vw;
          height: 10.667vw;
          background: #256fff;
          color: #ffffff;
        }
        .common {
          border-radius: 5.333vw;
          font-size: 3.733vw;
          line-height: 4.267vw;
          font-weight: 400;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
  /deep/ .ivu-select-selection {
    border: none;
  }
  /deep/ .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
    padding-left: 0;
    padding-right: 0;
    color: #000000;
    font-size: 3.733vw;
  }
  /deep/ .ivu-select-single .ivu-select-selection .ivu-select-placeholder {
    padding-left: 0;
    padding-right: 0;
    color: #d3d3d3;
    font-size: 3.733vw;
  }
  /deep/ .ivu-select-single .ivu-select-selection {
    height: 100%;
    display: flex;
    align-items: center;
  }
  /deep/ .ivu-select-arrow {
    right: 0px;
    color: #d3d3d3;
    font-size: 13px;
  }
  /deep/ .ivu-select-visible .ivu-select-selection {
    box-shadow: none;
  }
  /deep/ .ivu-select-arrow.clear-icon {
    right: 18px;
    color: #d3d3d3;
    font-size: 13px;
  }
  /deep/ .ivu-select-dropdown {
    left: 26.733vw !important;
    right: 20px !important;
    width: 48.133vw !important;
    margin-top: 1px !important;
  }
  /deep/ .ivu-select-item-selected.ivu-select-item-focus {
    background: #f8f8f8;
  }
  /deep/ .ivu-select-item-selected,
  .ivu-select-item-selected:hover {
    color: #256fff;
    background: #f8f8f8;
  }
  /deep/ .ivu-select-dropdown {
    margin: 0;
  }
  /deep/ .ivu-select-item {
    padding: 7px 1.867vw;
    font-size: 3.733vw !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/dynamicAttr/eduEducationCertification.vue